import $ from 'jquery';
import jQuery from 'jquery';
import whatInput from 'what-input';

window.$ = window.jQuery = $;

import Foundation from 'foundation-sites';
// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';

var Countdown = require('./lib/jquery.countdown');

//jQueryBridget( 'countdown', Countdown, $ );

import libs from './lib/dependencies';
window.libs = libs;


$(document).foundation();


// tablesaw table plugin
$(function () {
  $(document)
    .foundation();

  $("#totop").click(function(){
    event.preventDefault();
    $('body,html').animate({
      scrollTop: 0,
      }, 1000
    );
  });

  $("*[data-link]").click(function(){
    window.location = $(this).data('link');
    return false;
  });

  $('.carousel').slick({
    arrows: false,
    dots: true,
    autoplay: true,
    autoplaySpeed: 10000,
    speed: 500,
    pauseOnHover: false,
    rows: 0
  });


  $('.partner-slider').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 10000,
    speed: 1000,
    pauseOnHover: false,
    rows: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  $('div#countdown').countdown("2019/01/03").on('update.countdown', function(event) {
    $('div#countdown .months').text(event.strftime('%-m'));
    $('div#countdown .weeks').text(event.strftime('%-W'));
    $('div#countdown .days').text(event.strftime('%-d'));
    $('div#countdown .hours').text(event.strftime('%-H'));
    $('div#countdown .minutes').text(event.strftime('%M'));
    $('div#countdown .seconds').text(event.strftime('%S'));
  });


  var element = $("#imageModal");
  var revealer = new Foundation.Reveal(element);

  $('.gallery .items a').click(function(){
    var index = $('.gallery .items a').index(this);
    //console.log(index);
    openImage(index);
    return false;
  });

  $(window).on(
      'closed.zf.reveal', function () {
          //location.reload();
          $('iframe').each(function(){
            var player = $(this).get(0);
            postMessageToPlayer(player, {
              "event": "command",
              "func": "pauseVideo"
            });
            $(this).attr('src', $(this).attr('src'));
          })
      }
  );

  // POST commands to YouTube or Vimeo API
  function postMessageToPlayer(player, command){
    if (player == null || command == null) return;
    player.contentWindow.postMessage(JSON.stringify(command), "*");
  }

  reposition();

  $(window).on('resize', function(){
        setTimeout(reposition, 100);
  });
  $(window).scroll(function(){
    ( $(this).scrollTop() > 100 ) ? $("#totop").addClass('active') : $("#totop").removeClass('active');
  });


  function reposition() {
    if (Foundation.MediaQuery.atLeast('large')) {
      // $('.grid .box:not(".large")').each(function(){
      //   var height = ($(window).height()/2)-50;
      //   $(this).css('height', height);
      // });
      // $('.grid .box.large').each(function(){
      //   var height = ($(window).height())-100;
      //   $(this).css('height', height);
      // });
    } else {
      // $('.grid .box').css('height', '');
    }
  }

});

function openImage(index) {
  var element = $("#imageModal");
  element.css('opacity', 0);
  if(!$("#gallerySlider").hasClass('slick-initialized')) {
    $("#gallerySlider").slick({
      "arrows": true,
      "dots": false,
      'slidesToShow': 1,
      'slidesToScroll': 1,
      "fade": true,
      'speed': 1000,
      'rows': 0,
      'asNavFor': '#thumbsSlider'
    });
    $("#thumbsSlider").slick({
      "arrows": false,
      "dots": false,
      'slidesToShow': 9,
      'slidesToScroll': 9,
      'centerMode': false,
      'speed': 1000,
      'rows': 0,
      'asNavFor': '#gallerySlider',
      'focusOnSelect': true,
      'responsive': [
      {
        'breakpoint': 1024,
        'settings': {
          'slidesToShow': 8,
          'slidesToScroll': 8,
        }
      },
      {
        'breakpoint': 600,
        'settings': {
          'slidesToShow': 6,
          'slidesToScroll': 6
        }
      },
      {
        'breakpoint': 480,
        'settings': {
          'slidesToShow': 3,
          'slidesToScroll': 3
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
    });
  }
  $("#gallerySlider").slick('slickGoTo', index);
  element.foundation('open');
  element.animate({'opacity': 1}, 500);
  return false;
}